/**
 * !Do not add more functions here. all these checks must be done on the router definitions using contexts, not checking the paths.
 */

import { useBoardsQuery } from '@modules/board/hooks/useBoardsQuery';
import { matchPath } from 'react-router-dom';
import { useWorkspaceFeaturesSettings } from 'src/hooks/useWorkspace';
import {
  Section as RouterSessionKey,
  appLocationState,
  getCurrentSession,
  getSessionSlug,
} from 'src/state/restoreLocation';
import { routes } from '../Router';

export const pathsMap = (): Record<RouterSessionKey, string[]> => ({
  collaborate: [
    routes.dashboard.board.root,
    routes.dashboard.todo.root,
    routes.dashboard.docs.root,
    routes.dashboard.drive.root,
  ],
  communicate: [routes.dashboard.chat.root],
  ai: [routes.dashboard.ai.root],
});

export const isRouterSessionKey = (
  key: RouterSessionKey,
  currentPath: string,
) =>
  pathsMap()[key]?.some(
    (path) =>
      !!matchPath(
        {
          path,
          end: false,
        },
        currentPath,
      ),
  );

export const getCurrentSection = (pathName: string) => {
  return (Object.keys(pathsMap()) as RouterSessionKey[]).find((key) =>
    pathsMap()[key]?.some((path) => matchPath({ path, end: false }, pathName)),
  );
};

export const useCurrentSessionSectionsRecord = () => {
  const { smartTodos } = useWorkspaceFeaturesSettings();
  const { boards } = useBoardsQuery();

  return appLocationState(() => {
    const session = getCurrentSession();
    const sessionSlug = getSessionSlug(session);
    const recs = { ...session?.sectionRecords };

    const path = (route: string | null | undefined, fallback: string) => {
      if (route) return `/${sessionSlug}/${route}`;
      return fallback;
    };

    return {
      communicate: path(recs?.communicate, routes.dashboard.chat.root),
      collaborate: path(
        recs?.collaborate,
        smartTodos
          ? routes.dashboard.todo.root
          : boards?.[0]
            ? routes.dashboard.board.view(boards[0]._id)
            : routes.dashboard.board.root,
      ),
      ai: path(recs?.ai, routes.dashboard.ai.root),
    };
  });
};

export const getSectionPath = (pathName: string): string => {
  const parts = pathName.split('/').filter(Boolean);
  return parts[1] ?? 'settings';
};
